const noDigitosRegExp = /[^\d]/g;
/**
 * Dada una cadena de texto, retorna otra manteniendo solo aquellos caracteres que
 * sean dígitos y descartando cualquier otro.
 */
export function mantenerSoloDigitos(texto: string): string {
    return texto.replace(noDigitosRegExp, '');
}

const gruposDeTresRegExp = /\B(?=(\d{3})+(?!\d))/g;
/**
 * Dado un número o una cadena de texto, retorna una nueva cadena con los dígitos
 * agrupados de 3 en 3 y separados por puntos. Si la entrada es una cadena de texto
 * solo se mantendrán los caracteres que posean números. Si la entrada es `NaN` o
 * `+-Infinity` se retornará una cadena vacía. Si la entrada es un número decimal
 * se truncará.
 */
export function formatearConPuntosCadaTresDigitos(monto: number | string): string {
    const texto =
        typeof monto === 'number'
            ? Number.isFinite(monto)
                ? Math.trunc(monto).toString()
                : '' // si es un número no finito se deja a string vacío por diseño
            : mantenerSoloDigitos(monto);
    return texto.replace(gruposDeTresRegExp, '.');
}



// WEBPACK FOOTER //
// ./src/utilidades/formato.ts